module.exports = __webpack_public_path__ + "static/iso_17.b90dec92.png";